import React, { useEffect } from "react";
import { Input, InputProps } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import i18n from "../../i18n";
import { State } from "../../interfaces";
import { SelectListDto } from "../../models";
import { getCourseSelectListLocal } from "../../store/actions";
import { toast } from "react-toastify";

type TProps = InputProps & {
  placeholder: string;
};

export const CourseSelect: React.FC<TProps> = ({
  courseId,
  placeholder,
  ...props
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { response, loading, error } = useSelector(
    (state: any): State<SelectListDto[]> => state.course.courseSelectListLocal
  );

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!loading && error)
      toast.error(error, {
        autoClose: 3000,
      });
  }, [loading]);

  const getData = () => {
    dispatch(getCourseSelectListLocal());
  };

  return (
    <div className="input-group">
      <Input {...props}>
        <option value={""}>{t(placeholder)} </option>
        {response &&
          response.length &&
          response.map(({ id, value }) => (
            <option value={id} key={id} className="text-capitalize">
              {i18n.language === "ar" ? value.ar : value.en}
            </option>
          ))}
      </Input>
    </div>
  );
};
